import { render } from "./ButtonsEditor.vue?vue&type=template&id=6889580a&scoped=true"
import script from "./ButtonsEditor.vue?vue&type=script&lang=js"
export * from "./ButtonsEditor.vue?vue&type=script&lang=js"

import "./ButtonsEditor.vue?vue&type=style&index=0&id=6889580a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6889580a"

export default script